package com.milta.feature.auth.data.remote.dto

import kotlinx.serialization.Serializable

@Serializable
data class AuthenticateWithOAuthRequest(
    val provider: String,
    val idToken: String,
)
